import React, { useState } from "react";
import { Container, Row, Col, Card, Modal, Button } from "react-bootstrap";
import { FaLinkedin, FaArrowRight } from "react-icons/fa";
import { Awards } from "./Awards";
import { Testimonial } from "./Testimonial";
import "./About.css";

// --- Sub-Component: Leadership Card ---
const LeadershipCard = ({ data }) => {
  const [show, setShow] = useState(false);

  return (
    <>
      <Card className="team-card shadow-sm h-100" onClick={() => setShow(true)}>
        <div className="img-wrapper">
          <Card.Img variant="top" src={data.imgUrl} className="team-img" />
        </div>
        <Card.Body className="text-center p-4">
          <Card.Title className="team-name">{data.caption}</Card.Title>
          <Card.Text className="team-role">Leadership Team</Card.Text>
          <div className="mt-3 text-primary d-flex align-items-center justify-content-center" style={{fontSize: '0.9rem'}}>
             View Profile <FaArrowRight className="ms-2" size={12}/>
          </div>
        </Card.Body>
      </Card>

      {/* Modal */}
      <Modal style={{zIndex:"99999999999"}} show={show} onHide={() => setShow(false)} size="lg" centered>
        <Modal.Header closeButton>
          <Modal.Title className="fw-bold">{data.caption}</Modal.Title>
        </Modal.Header>
        <Modal.Body className="p-4">
          <Row>
            <Col md={5} className="mb-4 mb-md-0">
              <img src={data.imgUrl} alt={data.caption} className="modal-profile-img" />
              
              <div className="mt-4 text-center">
                 <a href={data.link} target="_blank" rel="noopener noreferrer" className="text-decoration-none d-inline-flex align-items-center linkedin-btn">
                    <FaLinkedin size={28} className="me-2" />
                    <span className="fw-bold">Connect on LinkedIn</span>
                 </a>
              </div>
            </Col>
            <Col md={7}>
              <h5 className="mb-3 text-dark fw-bold">Professional Profile</h5>
              <div className="modal-text">
                <p>{data.description}</p>
                {data.description1 && <p>{data.description1}</p>}
                {data.description2 && <p>{data.description2}</p>}
              </div>
            </Col>
          </Row>
        </Modal.Body>
        {/* <Modal.Footer>
          <Button variant="outline-secondary" className="custom-button2" onClick={() => setShow(false)}>
          <span>Close</span>
          </Button>
        </Modal.Footer> */}
      </Modal>
    </>
  );
};

// --- Main Component: About ---
export const About = () => {
  const teamData = [
    {
      id: 1,
      imgUrl: "https://techsawebsiteimages.s3.ap-south-1.amazonaws.com/RAVISIR.png",
      caption: "Ravi Khanchandani",
      link: "https://www.linkedin.com/in/ravikhanchandani",
      description: "Over 3 decades of rich experience in the IT industry, including 15+ years of running Techsa. Past experience comes from various profiles and positions held ranging from Support Engineer, Network Engineer, Systems Integration, Regional SI Manager, Technical Manager, Sr. Systems Engineer, Principal Consultant, Business Development Manager - Security, Regional Systems Engineering Manager, Country Manager - Systems Engineering and now an Entrepreneur role.",
      description1: "All roles have provided me diverse skills from managing customers, partners, technology & managing diverse teams. Rich exposure in different technical domains - Networking, Content Switching, Security, Unified Communications, IT Infrastructure Management, Endpoint Management, Data Center Architectures and more.",
      description2: "Good communication & presentation skills, a head for Sales & business, creative in approach towards various issues & excellent man-management.",
    },
    {
      id: 2,
      imgUrl: "https://techsawebsiteimages.s3.ap-south-1.amazonaws.com/SanjivSachdev.jpg",
      caption: "Sanjiv Sachdev",
      link: "https://www.linkedin.com/in/sanjivsachdev",
      description: "Sanjiv holds a Bachelor's Degree in Engineering with specialization in Electronics. He is a passionate and adventurous technologist with core strengths in result-oriented Business Development & Growth Management. With nearly three decades of experience in the Information Technology Industry, Sanjiv has established himself as a seasoned professional.",
      description1: "Based out of India, Sanjiv has worked extensively with global clients in North America and EMEA. He has successfully built a niche for Techsa Services, known as a specialist in the domain and solutions offered by them. Prior to founding and managing the Sales & General Administration of Techsa Services Pvt Ltd for close to 15+ years, Sanjiv held various leadership profiles in Account Management.",
      description2: "An animal lover with immense empathy for humanity, Sanjiv is also committed to giving back to society. He specializes in Commercial Innovation, P&L Management, and supporting Start-ups, adhering to the philosophy of 'Work Hard; Play Hard' at Techsa Services.",
    },
  ];

  return (
    <div className="about-section py-5 ">
      <Container>
        {/* Header Section */}
        <div className="text-center mb-5">
          <h1 className="section-title display-5">Brief About Us</h1>
          <div className="mx-auto bg-danger rounded mb-4" style={{width: '60px', height: '4px'}}></div>
          <p className="section-subtitle">
            We team up with industry-leading technology partners to deliver
            innovative solutions. Our strategic alliances with these industry
            leaders empower us to stay ahead of the curve.
          </p>
        </div>

        {/* Leadership Section */}
        <div className="mb-5">
            <h2 className="text-center mb-5 fw-bold text-danger">Meet Our Leadership</h2>
            <Row className="justify-content-center g-4">
            {teamData.map((member) => (
                <Col key={member.id} xs={12} sm={8} md={6} lg={4}>
                   <LeadershipCard data={member} />
                </Col>
            ))}
            </Row>
        </div>

        <hr className="my-5 opacity-25" />

        {/* Awards Section */}
        <div className="mb-5">
          <h2 className="text-center mb-5 fw-bold text-danger">Awards & Recognition</h2>
          <Awards />
        </div>

        <hr className="my-5 opacity-25" />

        {/* Testimonials */}
        <Testimonial />
      </Container>
    </div>
  );
};